const gradeYearData = {
  highSchoolGrades: [
    {
      label: '9th Grade',
      value: '9',
    },
    {
      label: '10th Grade',
      value: '10',
    },
    {
      label: '11th Grade',
      value: '11',
    },
    {
      label: '12th Grade',
      value: '12',
    },
  ],
  collegeGrades: [
    {
      label: '1st Year College',
      value: 'Year 1 Post Secondary',
    },
    {
      label: '2nd Year College',
      value: 'Year 2 Post Secondary',
    },
    {
      label: '3rd Year College',
      value: 'Year 3 Post Secondary',
    },
    {
      label: '4th Year College',
      value: 'Year 4 Post Secondary',
    },
  ],
};

export { gradeYearData };
